// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isAppsEngagementReportsEngagementReportDataResult = objectOf({
  id: string,
  name: string,
  compression: string,
  delimiter: string,
  selected_kpis_as_json: arrayOf(string),
  email_to: arrayOf(string),
  has_completed_wizard: boolean,
  num_days_to_aggregate: number,
  num_days_for_rolling_window: number,
  aggregate_by_entire_message: boolean,
  use_rolling_window: boolean,
  tag_selected: boolean,
  start_date: number,
  end_date: number,
  send_immediately: boolean,
  tag_names: arrayOf(string),
  exclude_archived: boolean,
  marked_as_deleted: boolean,
  schedule_data: objectOf({
    start_date_time: number,
    deliver_in_local_time: boolean,
    optimal_time_notification: boolean,
    use_app_group_best_time: boolean,
    optimal_time_default_hour: number,
    optimal_time_default_minute: number,
    quiet_start_hour: number,
    quiet_start_minute: number,
    quiet_end_hour: number,
    quiet_end_minute: number,
    has_quiet_time: boolean,
    content_card_delivery_control: string,
    display_text: string,
    next_occurrence: number,
    last_occurrence: number,
    recurring: boolean,
  }),
  selected_campaigns: arrayOf(
    objectOf({
      campaign_name: string,
      id: string,
      messaging_actions: arrayOf(
        objectOf({
          message_type: string,
        })
      ),
      created: objectOf({
        time: number,
      }),
      campaign_type: string,
      is_archived: boolean,
    })
  ),
  selected_workflows: arrayOf(
    objectOf({
      campaign_name: string,
      id: string,
      steps: arrayOf(
        objectOf({
          messaging_actions: arrayOf(
            objectOf({
              message_type: string,
            })
          ),
        })
      ),
      created: objectOf({
        time: number,
      }),
      is_archived: boolean,
    })
  ),
});
